import { ISetScheduleParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class SetSubscriptionsScheduleRequest extends Request<ISetScheduleParams, IResult> {
  constructor(ids: string[], scheduleId: string) {
    super('setSubscriptionsSchedule', {
      ids: ids,
      scheduleId: scheduleId
    });
  }
}
